module.exports = __webpack_public_path__ + "img/newImg5.c224f529.jpg";